export const en = {
    translation: {
        meta: {
            'en-GB': 'Deutsche Version',
            logout: 'Log out',
            refresh: 'Refresh Token',
        },
        lead: {
            list: {
                tableHead: {
                    leadId: 'Lead ID',
                    leadSource: 'Lead source',
                    leadCreationTimestamp: 'Created at',
                    status: 'Working state',
                    customerEmail: 'Customer e-mail address',
                    contractId: 'Contract',
                    customerType: 'Contract type',
                    companyName: 'Company',
                    armadaCustomerId: 'Armada Customer',
                    leasmanCustomerId: 'Leasman Customer',
                    customerFullName: 'Name / Counterpart',
                    publicationTitle: 'Category',
                },
                messages: {
                    nothing: 'No matching data found.',
                },
                tools: {
                    refresh: 'Refresh',
                    excelExport: 'Export to Excel',
                    filterSpam: 'Hide repeated requests',
                    all: 'all',
                },
                tabs: {
                    workflowTodos: 'Leads for manual processing',
                    workflowOpen: 'all open leads',
                    allLeads: 'all leads',
                },
                multipleRequests: 'Repeated requests in short time',
            },
            detail: {
                tools: {
                    refresh: 'Update details',
                    back: 'back to overview',
                    task: 'Manual Workflow',
                    tasks: {
                        ARMADA_CUSTOMER_CREATION: 'Send Armada customer id',
                        LEASMAN_CUSTOMER_CREATION: 'Send Leasman customer id',
                        MASTER_CONTRACT_ASSIGNMENT: 'Send master contract Id',
                        CREDIT_CHECK: 'Send result of credit check',
                        CANCEL: 'Close lead',
                        CONTRACT_ACTIVATION: 'Activate contract',
                        CLOSE_LEASMAN_CONTRACT: 'Close Leasman contract',
                    },
                },

                box: {
                    general: {
                        headline: 'General',
                        leadSource: 'Lead source',
                        leadId: 'Lead Id',
                        leadState: 'Current state',
                        type: 'Contract type',
                        armadaCustomerId: 'Armada customer id',
                        leasmanCustomerId: 'Leasman customer id',
                        creationTimestamp: 'Created at',
                    },
                    marketingData: {
                        headline: 'Marketing campaign',
                        partner: 'Partner',
                        details: 'Click-through values',
                    },
                    documents: {
                        emptyMessage: 'No documents present',
                        headline: 'Documents from onboarding',
                        manDocHeadline: 'Manually entered documents',
                        DOCUMENT_TYPE_LETTER_OF_ATTORNEY: 'Letter of attorney',
                        DOCUMENT_TYPE_LETTER_OF_ATTORNEY_SIGNER_ID: 'Signer ID for letter of attorney',
                        DOCUMENT_TYPE_TRADE_REGISTRY_RECORD: 'Trade registry record',
                        DOCUMENT_TYPE_FOUNDATION_REGISTRY_RECORD: 'Foundation registry record',
                        DOCUMENT_TYPE_COOPERATIVE_REGISTRY_RECORD: 'Cooperative registry record',
                        DOCUMENT_TYPE_BUSINESS_REGISTRY_RECORD: 'Business registry record',
                        DOCUMENT_TYPE_PARTNERSHIP_AGREEMENT: 'Partnership aggreement',
                        DOCUMENT_TYPE_ASSOCIATION_REGISTRY_RECORD: 'Association registry record',
                        DOCUMENT_TYPE_PROOF_OF_COMMERCIAL_ACTIVITY: 'Proof of commercial activity',
                        DOCUMENT_TYPE_TRANSPARENCY_REGISTRY_RECORD: 'Transparency register record',
                        DOCUMENT_TYPE_PROOF_OF_RESIDENCE: 'Proof of residence',
                        DOCUMENT_TYPE_KYC_SHEET: 'KYC-Sheet',
                    },
                    customer: {
                        headline: {
                            PRIVATE: 'Customer data',
                            BUSINESS: 'Contact person',
                        },
                        knownCustomer: 'already a customer?',
                        knownCustomerValue: {
                            true: 'yes',
                            false: 'no',
                        },
                        title: 'Title',
                        firstName: 'Firstname',
                        lastName: 'Lastname',
                        birthdate: 'Birthdate',
                        email: 'E-Mail',
                        mobilePhoneNumber: 'Mobile phone number',
                        city: 'City',
                        country: 'Country',
                        houseNumber: 'House number',
                        postalCode: 'Postal code',
                        ort: 'Place',
                        streetName: 'Street',
                        addressAddition: 'Address addition',
                        person: 'Person',
                        address: 'Address',
                        employedSince: 'employs since',
                        instantLeaseCustomer: 'Instant-Lease customer view',
                        '--': '',
                    },
                    leadCreator: {
                        headline: 'Lead creator',
                        firstName: 'Firstname',
                        lastName: 'Lastname',
                        email: 'E-Mail',
                    },
                    signer: {
                        firstName: 'Firstname',
                        lastName: 'Lastname',
                        birthdate: 'Birthdate',
                        email: 'E-Mail',
                        mobilePhoneNumber: 'Mobile phone number',
                        city: 'City',
                        country: 'Country',
                        houseNumber: 'House number',
                        postalCode: 'Postal code',
                        streetName: 'Street',
                        addressAddition: 'Address addition',
                        address: 'Address',
                        consentGivenAt: 'WebID consent given at:',
                    },
                    bankAccount: {
                        headline: 'Bank account',
                        bankAccountOwner: 'Bank account owner',
                        bankName: 'Bank',
                        iban: 'IBAN',
                        bic: 'BIC',
                    },
                    contract: {
                        headline: 'Contract data',
                        publicationId: 'Publication',
                        mileage: 'Inclusive mileage',
                        duration: 'Duration (month)',
                        rateNet: 'net',
                        rateGross: 'gross',
                        rate: 'Rate',
                        category: 'Category',
                        campaignTitle: 'Campaign',
                        totalPrice: 'Total price',
                        leasmanMasterId: 'Leasman master',
                        leasmanContractId: 'Leasman contract',
                    },
                    company: {
                        headline: 'Company',
                        name: 'Company name',
                        legalForm: 'Legal form',
                        localCourt: 'Local court',
                        vatId: 'VAT number',
                        commercialRegisterNumber: 'Commercial register number',
                        foundingDate: 'Founding date',
                        streetName: 'Street',
                        houseNumber: 'House number',
                        addressAddition: 'Address addition',
                        city: 'City',
                        country: 'Country',
                        postalCode: 'Postal code',
                        address: 'Address',
                        beneficialOwners: {
                            headline: 'Beneficial owners',
                            person: {
                                firstName: 'Firstname',
                                lastName: 'Lastname',
                                postalWithLocality: 'Place',
                                role: 'Role',
                            },
                        },
                        authorizedRepresentatives: {
                            headline: 'Authorized representatives',
                            person: {
                                firstName: 'Firstname',
                                lastName: 'Lastname',
                                role: 'Role',
                            },
                        },
                        phoneNumber: 'Phone number',
                        emailDefault: 'E-Mail',
                        emailInvoice: 'E-Mail (Invoice)',
                        emailSepa: 'E-Mail (SEPA debit)',
                        '--': '',
                    },

                    delivery: {
                        headline: 'Delivery',
                        product: 'Product',
                        priceNet: 'net',
                        priceGross: 'gross',
                        priceFree: 'for free',
                        price: 'One time charges',
                        _: '',
                        types: {
                            HOME_DELIVERY: 'Home delivery',
                            PICK_UP: 'Pick up vehicle',
                        },
                        deliveryDate: 'Desired date',
                        deliveryTime: '',
                        deliveryTimes: {
                            MORNING: 'Morning',
                            AFTERNOON: 'Afternoon',
                        },
                        soonAsPossible: 'as soon as possible',
                    },
                    KYC: {
                        missing: {
                            headline: 'Identification result',
                            description: 'Identification has not been invoked yet.',
                        },
                        signer: {
                            headline: 'Signers',
                            name: 'Name',
                            state: 'Status',
                            emptyMessage: 'No signers present',
                            details: 'Signer details',
                            consent: 'WebID consent',
                            authorized: 'authorized',
                            representative: 'representative',
                        },
                        idNow: {
                            headline: 'Identification result (IDnow)',
                            status: 'Status',
                            date: 'Identification date',
                        },
                        webId: {
                            headline: 'Identification result (WebId)',
                            status: 'Status',
                            date: 'Date',
                        },
                    },
                    identificationLog: {
                        headline: 'Identification events',
                        result: 'Result',
                        reason: 'Reason',
                        timestamp: 'Date',
                        emptyMessage: 'No results yet',
                    },
                    idNow: {
                        headline: 'Current status at IDnow',
                        infoHeadline: 'Identification is pending',
                        infoText: 'The customer has not yet been sent to IDnow!',
                    },
                    mailjetEvents: {
                        headline: 'MailJet Events',
                        button: 'Show MailJet Events',
                        errorHeadline: 'Something went wrong!',
                        errorHint: 'Please try again later.',
                        noDataHint: 'No MailJet events available.',
                        table: {
                            mailType: 'Mailtype',
                            date: 'Date',
                            event: 'Event',
                            payload: 'Payload',
                        },
                    },
                },

                errors: {
                    headline: 'Errors have occurred',
                    retry: 'Retry',
                    message: 'Message',
                },
            },
            errors: {
                auth: 'You are not authorized to access this data: ',
                generic: 'Error on loading data: ',
                metadata: 'Metadata',
                leadData: 'Lead information',
            },
            fields: {
                post: 'Send data',
                armadaCustomerId: 'Input armada customer id',
                leasmanCustomerId: 'Input leasman customer id',
                leasmanMasterContractId: 'Input master contract ID',
                pleaseSelect: 'please select',
                errorEmpty: 'Fill field with a value',
                errorNumbersOnly: 'Only numbers with thousands separator allowed (e.g. 123.456)',
                question1: 'Should the process really be closed?',
                cancel: 'Close process',
                abort: 'Abort',
                contractActivation: 'Please press button "Send data" for it.',
                creditCheck: 'Here the result from the credit check is needed for the workflow',
                creditCheck_SUCCESS: 'Passed',
                creditCheck_REJECT: 'Rejected',
            },
        },
        publicationEditor: {
            headline: 'Publication-Editor',
            back: 'Back',
            next: 'Next',
            abort: 'Abort',
            save: 'Save',
            confirmDialog: {
                headline: 'Apply changes?',
                hint: 'Make sure you have made a copy of the publication',
                success: 'Changes successfully applied',
                error: 'An error occurred',
            },
            steps: {
                selectPublication: {
                    label: 'Select publication',
                },
                editPublication: {
                    label: 'Edit publication',
                    validationError: 'Invalid JSON',
                },
                verifyPublication: {
                    label: 'Verify publication',
                    old: 'Old',
                    new: 'New',
                },
            },
        },
        carlos: {
            errors: {
                api: 'Error while loading data from Carlos',
            },
        },
    },
};
